// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "rescript/lib/es6/caml_array.js";

function getDomain(url) {
  var domain = url;
  domain = domain.includes("://") ? Caml_array.get(domain.split("/"), 2) : Caml_array.get(domain.split("/"), 0);
  return Caml_array.get(domain.split(":"), 0);
}

export {
  getDomain ,
  
}
/* No side effect */
